import { defineMessages } from 'react-intl';

const messages = defineMessages({
  text: {
    id: 'Sponsortext',
    defaultMessage: 'Text for sponsors block',
  },
  default: {
    id: 'SponsordefaultText',
    defaultMessage:
      'Diese Maßnahme wird mitfinanziert durch Steuermittel auf der Grundlage des vom Sächsischen Landtag beschlossenen Haushaltes',
  },
  defaultFieldset: {
    id: 'defaultFieldset',
    defaultMessage: 'default',
  },
  items: {
    id: 'items',
    defaultMessage: 'Items',
  },
  item: {
    id: 'item',
    defaultMessage: 'Sponsor',
  },
});

export const sponsorsBlockSchema = (props) => {
  const { intl } = props;

  return {
    title: 'Sponsors Block',
    description: 'Display Sponsors',
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.defaultFieldset),
        fields: ['managed', 'items'],
      },
    ],
    properties: {
      // text: {
      //   title: intl.formatMessage(messages.text),
      //   widget: 'textarea',
      //   defaultValue: intl.formatMessage(messages.default),
      // },
      managed: {
        title: 'Manage',
        description: 'Manage items manually and not from behavior',
        type: 'boolean',
        defaultValue: false,
      },
      items: {
        title: intl.formatMessage(messages.items),
        vocabulary: { '@id': 'saw.persons.Sponsors' },
        widget: 'array',
      },
    },
    required: [],
  };
};

export default sponsorsBlockSchema;
